module.exports = __webpack_public_path__ + "static/images/no-available-service.116vLP7.svg";